var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-portlet__head-label"},[_c('h3',{staticClass:"kt-portlet__head-title"},[_vm._v(_vm._s(_vm.headTitle)+" "),_c('small',[_vm._v(_vm._s(_vm.subTitle ? _vm.subTitle : ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }